// extracted by mini-css-extract-plugin
export var container = "_ti-0";
export var table = "_ti-2";
export var tableWrapper = "_ti-1";